import React from "react";
import "./ProductCard.css";

const ProductCard = ({ name, image }) => {
  return (
    <div className="card">
      <img src={image} alt={name} />
      <h3>{name}</h3>

      <a href="tel:9732108660">
  <button className="btn">📞 Call Now</button>
</a>
    </div>
  );
};

export default ProductCard;